export default "__VITE_PUBLIC_ASSET__755ffe62__"